<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";
  
  </script>

<Card>
  <CardBody>
    <div class="mb-4 h1 card-title">Notice</div>
    
        <p class="card-text h5">
            모델 제출 방법 추가 및 기한 연장 안내
        </p>

        <ul>
          <li>
            참가 등록 마감 : ~ 2022. 12. 4.까지 (종전과 동일) <br/>
            모델 제출 기한 : ~ <b>2022. 12. 18.까지</b>
          </li>
          <li>
            기존의 codalab을 사용한 방법 이외에, <b>이메일</b>을 통한 모델 제출도 가능합니다.<br/>
            <ul>
            <li>
            이메일(klaid@lawcompany.co.kr)로 모델 파일 및 실행 스크립트 등과 환경구성 방법을 포함한 실행 방법을 보내주시면, 모델을 직접 테스트하여 리더보드에 등록합니다.
            </li>
            </ul>
          </li>
          <li>
            그 밖의 문의사항에 대해서도 이메일(klaid@lawcompany.co.kr)로 언제든 문의주시기 바랍니다.
          </li>
        </ul>

      <p class="card-text h5">
        LawTalk neural model helper 공개
      </p>
      <ul>
        <li>
huggingface Trainer를 바탕으로 한 model train helper로 huggingface를 사용하시는 분들이 모델의 hyperparameter fine-tuning을 한번에 다양하게 적용하여 모델을 학습시킬 수 있도록 도와주고, 각각의 모델에 대한 평가도 자동으로 진행할 수 있도록 도와주는 도구입니다.
        </li>
        <li>현재 KLAID의 LJP task가 default data in-output으로 구성되어 있습니다.</li>
        <li>
          <a href="https://github.com/lawcompany/law_talk_neural_model_helper" target="_blank">github 페이지 바로가기</a>
        </li>
      </ul>
      
  </CardBody>
  </Card>

<Card>
  <CardBody>
    <div class="mb-4 h1 card-title">Notice</div>
    
        <p class="card-text h5">
            데이터셋 업데이트 (2022. 11. 15.)
        </p>

        <ul>
          <li>
            라벨 갯수 변경 (178개 -> 177개)
          </li>
          <li>
            라벨 갯수 변경에 따른 Baseline 모델 업데이트
          </li>
        </ul>
      
  </CardBody>
  </Card>
  
  <Card>
  <CardBody>
    <div class="mb-4 h1 card-title">Notice</div>
    
        <p class="card-text h5">
            2022 KLAID CHALLENGE가 시작되었습니다.
        </p>

        <Card>
            <CardBody>
              <div class="mb-4 h1 card-title">대회 기간</div>
                  <p class="card-text h5">
                      2022. 11. 14.(월) ~ 2022. 12. 4.(일)
                  </p>
            </CardBody>
        </Card>
        <Card>
            <CardBody>
              <div class="mb-4 h1 card-title">참가 대상</div>
                  <p class="card-text h5">
                      국내/외 대학(원)생
                  </p>
            </CardBody>
        </Card>
        <Card>
            <CardBody>
              <div class="mb-4 h1 card-title">시상</div>
                  <p class="card-text h5">
                      1등 300만 원
                  </p>
                  <p class="card-text">
                      ※ Leaderboard 순위 (Macro F1 score) 기준<br/>
                      ※ 제세공과금 본인 부담
                  </p>
            </CardBody>
        </Card>
        <Card>
            <CardBody>
              <div class="mb-4 h1 card-title">데이터셋 & Task</div>
                  <p class="card-text h5">
                    KLAID 데이터셋 중 LJP task<br/>
                  </p>
                    <ul>
                    <li>
                    <a href="https://huggingface.co/datasets/lawcompany/KLAID" target="_blank">DATASET CARD 바로가기</a><br/>
                    </li>
                    <li>
                      <a href="https://huggingface.co/lawcompany/KLAID_LJP_base" target="_blank">Baseline MODEL CARD 바로가기</a>
                    </li>
                  </ul>
                  
            </CardBody>
        </Card>
        <Card>
            <CardBody>
              <div class="mb-4 h1 card-title">참가 규칙</div>
                  <p class="card-text h5">
                    <a href="/challenge-rules" target="_blank">참가 규칙</a>
                  </p>
            </CardBody>
        </Card>
      
  </CardBody>
  </Card>
  
  